import type { FeedLike, FeedUser } from "../types/feed.ts"

function mapLikeUserFromUnknown(u: Record<string, unknown>): FeedUser | null {
  const rawId = u.id ?? u.user_id
  if (rawId == null || rawId === "") return null
  return {
    id: rawId as number | string,
    name: (u.name as string | undefined) ?? undefined,
    last_name: (u.last_name ?? u.lastName) as string | undefined,
    razon_social: u.razon_social as string | undefined,
    type: u.type as FeedUser["type"] | undefined,
    image_profile: (u.image_profile ?? u.imageProfile) as string | undefined,
  }
}

export function normalizePostLikeEntry(entry: unknown): FeedLike | null {
  if (entry == null || typeof entry !== "object") return null
  const e = entry as Record<string, unknown>
  let user: FeedUser | undefined
  const uRaw = e.user
  if (uRaw != null && typeof uRaw === "object" && !Array.isArray(uRaw)) {
    const mapped = mapLikeUserFromUnknown(uRaw as Record<string, unknown>)
    if (mapped) user = mapped
  }
  const fallbackId = e.user_id ?? e.userId
  if (!user && fallbackId != null && fallbackId !== "") {
    user = { id: fallbackId as number | string }
  }
  if (!user || user.id === undefined || user.id === "") return null
  return {
    id: typeof e.id === "number" ? e.id : e.id != null ? Number(e.id) : undefined,
    user,
    user_id: e.user_id as number | string | undefined,
  }
}

export function normalizePostLikes(raw: unknown): FeedLike[] {
  if (!Array.isArray(raw)) return []
  const out: FeedLike[] = []
  for (const x of raw) {
    const like = normalizePostLikeEntry(x)
    if (like) out.push(like)
  }
  return out
}
